import { render, staticRenderFns } from "./ProjectTask.vue?vue&type=template&id=d34cab28&scoped=true"
import script from "./ProjectTask.vue?vue&type=script&lang=js"
export * from "./ProjectTask.vue?vue&type=script&lang=js"
import style1 from "./ProjectTask.vue?vue&type=style&index=1&id=d34cab28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34cab28",
  null
  
)

export default component.exports